<template>
  <div class="header-container">
    <header class="section path-header text-center animCont">
      <!-- Branded header updated to include "33" as per site33.docx -->
      <div>
        <div class="topHeader">
          <h1 class="boldFont ginourmousOnDesktop">
            The <span class="serif text-left lowerOnDesktop">33 Path</span>
          </h1>

          <!-- <h1 class="boldFont">
            The <span class="serif lowerOnDesktop text-left">33 Path</span>
          </h1> -->
          <p
            class="topHeaderNote animate text-left smallFontSize fadeInLeft noMarginBottom"
          >
            The33Path is a transmedia cinematic universe authored by Patricia
            Ribeiro. It is intended for aligned producers, studios, and cultural
            financiers seeking to collaborate on a new paradigm of storytelling
            - where art, consciousness, and commerce merge into a single living
            ecosystem. All visual references on this page are placeholders.
          </p>
          <p
            class="topHeaderNote animate text-left smallFontSize fadeInLeft noMarginBottom"
            style="margin-top: var(--smallSpace)"
          >
            All rights to the mythology, characters, and story architecture
            remain under the sole authorship of Patricia Ribeiro. The vision is
            protected at its source while remaining open to collaboration with
            aligned partners capable of upholding its integrity.
          </p>
        </div>
        <div class="triangleTextCont">
          <div class="triangleText row fullWidth alignCentreRow alignTopRow">
            <div class="theWorld animate fadeInRight"><h1>The world</h1></div>

            <div class="isAStage animate fadeInRight">
              <h1>is<span class="serif textColour"> a stage</span></h1>
            </div>
          </div>
          <img
            :src="photoImage"
            alt="Photo"
            class="marginTopBottom trianguleImg animate zoomIn"
          />
        </div>
        <div class="column alignCentreColumn author-imageContCont">
          <div class="author-image-container">
            <div class="rgb-displacement-container">
              <!-- Using different colored versions of the barbara image -->
              <img
                :src="barbaraPurpleImage"
                alt="Author"
                class="author-image-duplicate red-duplicate marginTopBottom fadeInRight animate"
              />
              <img
                :src="barbaraGoldImage"
                alt="Author"
                class="author-image-duplicate green-duplicate marginTopBottom fadeInRight animate"
              />
              <img
                :src="barbaraTealImage"
                alt="Author"
                class="author-image-duplicate blue-duplicate marginTopBottom fadeInRight animate"
              />

              <!-- White image hidden with display:none -->
              <img
                :src="barbaraWhiteImage"
                alt="Author"
                class="author-image hidden marginTopBottom"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="topHeaderBottomNoteCont fullWidth">
        <p
          class="topHeaderBottomNote animate text-right smallFontSize fadeInLeft"
        >
          The33Path is the live transmission unfolding upon it, a story born
          from a self-generated universe you may already belong to.
        </p>
      </div>
    </header>
  </div>
</template>

<script>
import { ref, onMounted } from "vue";

export default {
  name: "ThePathHeader",
  setup() {
    // Update logo placeholder text to reflect "The 33 Path"
    const logoImage = ref(
      "https://via.placeholder.com/300x100?text=The+33+Path"
    );
    const barbaraRedImage = ref(
      require("@/assets/images/barbara_3_red.png").default
        ? require("@/assets/images/barbara_3_red.png").default
        : require("@/assets/images/barbara_3_red.png")
    );
    const barbaraGreenImage = ref(
      require("@/assets/images/barbara_3_green.png").default
        ? require("@/assets/images/barbara_3_green.png").default
        : require("@/assets/images/barbara_3_green.png")
    );
    const barbaraBlueImage = ref(
      require("@/assets/images/barbara_3_blue.png").default
        ? require("@/assets/images/barbara_3_blue.png").default
        : require("@/assets/images/barbara_3_blue.png")
    );
    const barbaraPurpleImage = ref(
      require("@/assets/images/barbara_3_purple.png").default
        ? require("@/assets/images/barbara_3_purple.png").default
        : require("@/assets/images/barbara_3_purple.png")
    );
    const barbaraGoldImage = ref(
      require("@/assets/images/barbara_3_gold.png").default
        ? require("@/assets/images/barbara_3_gold.png").default
        : require("@/assets/images/barbara_3_gold.png")
    );
    const barbaraTealImage = ref(
      require("@/assets/images/barbara_3_teal.png").default
        ? require("@/assets/images/barbara_3_teal.png").default
        : require("@/assets/images/barbara_3_teal.png")
    );

    const barbaraWhiteImage = ref(
      require("@/assets/images/barbara_3_white.png").default
        ? require("@/assets/images/barbara_3_white.png").default
        : require("@/assets/images/barbara_3_white.png")
    );
    const photoImage = ref(require("@/assets/images/triangle.png"));

    onMounted(() => {
      // Set up the RGB displacement effect only (removing grain animation)
      setupRGBDisplacementEffect();
    });

    const setupRGBDisplacementEffect = () => {
      const container = document.querySelector(".rgb-displacement-container");
      if (!container) return;

      // Get the duplicate image elements
      const redDuplicate = container.querySelector(".red-duplicate");
      const greenDuplicate = container.querySelector(".green-duplicate");
      const blueDuplicate = container.querySelector(".blue-duplicate");

      let lastMouseX = 0;
      let lastMouseY = 0;
      let mouseSpeedX = 0;
      let mouseSpeedY = 0;
      let isActive = false;
      let animationFrame = null;
      let decayFactor = 0.95; // Controls how quickly the movement slows down
      let isHovering = false; // Track if mouse is hovering over container

      // Set all duplicates to be in the exact same position initially
      function resetAllToCenter() {
        if (redDuplicate) {
          redDuplicate.style.transform = "translate(0px, 0px)";
          redDuplicate.style.transition =
            "transform 0.3s ease-out, opacity 0.3s ease";
          redDuplicate.style.opacity = "0.4";
        }
        if (greenDuplicate) {
          greenDuplicate.style.transform = "translate(0px, 0px)";
          greenDuplicate.style.transition =
            "transform 0.3s ease-out, opacity 0.3s ease";
          greenDuplicate.style.opacity = "0.4";
        }
        if (blueDuplicate) {
          blueDuplicate.style.transform = "translate(0px, 0px)";
          blueDuplicate.style.transition =
            "transform 0.3s ease-out, opacity 0.3s ease";
          blueDuplicate.style.opacity = "0.4";
        }
      }

      // Set initial positions to center with explicit pixel values
      resetAllToCenter();

      // Track mouse movement for desktop with smoother transitions
      container.addEventListener("mouseenter", () => {
        isHovering = true;
      });

      container.addEventListener("mouseleave", () => {
        isHovering = false;
        isActive = false;

        // Cancel any ongoing animations
        if (animationFrame) {
          cancelAnimationFrame(animationFrame);
          animationFrame = null;
        }

        // Reset all duplicates to center when mouse leaves
        resetAllToCenter();
      });

      container.addEventListener("mousemove", (e) => {
        if (!isHovering) return;

        const rect = container.getBoundingClientRect();
        const mouseX = e.clientX - rect.left;
        const mouseY = e.clientY - rect.top;

        // Calculate mouse speed
        mouseSpeedX = mouseX - lastMouseX;
        mouseSpeedY = mouseY - lastMouseY;

        lastMouseX = mouseX;
        lastMouseY = mouseY;

        // Use lower threshold for more responsive movement
        if (Math.abs(mouseSpeedX) > 2 || Math.abs(mouseSpeedY) > 2) {
          isActive = true;
          // Cancel any ongoing animations
          if (animationFrame) {
            cancelAnimationFrame(animationFrame);
            animationFrame = null;
          }
          updateDisplacement(mouseSpeedX, mouseSpeedY);
        }
      });

      // Handle touch events for mobile
      container.addEventListener("touchstart", () => {
        isHovering = true;
      });

      container.addEventListener("touchend", () => {
        isHovering = false;
        isActive = false;

        // Cancel any ongoing animations
        if (animationFrame) {
          cancelAnimationFrame(animationFrame);
          animationFrame = null;
        }

        // Reset all duplicates to center when touch ends
        resetAllToCenter();
      });

      container.addEventListener("touchmove", (e) => {
        if (!isHovering || e.touches.length === 0) return;

        const rect = container.getBoundingClientRect();
        const touchX = e.touches[0].clientX - rect.left;
        const touchY = e.touches[0].clientY - rect.top;

        // Calculate touch speed
        mouseSpeedX = touchX - lastMouseX;
        mouseSpeedY = touchY - lastMouseY;

        lastMouseX = touchX;
        lastMouseY = touchY;

        // Use lower threshold for more responsive movement
        if (Math.abs(mouseSpeedX) > 1 || Math.abs(mouseSpeedY) > 1) {
          isActive = true;
          // Cancel any ongoing animations
          if (animationFrame) {
            cancelAnimationFrame(animationFrame);
            animationFrame = null;
          }
          updateDisplacement(mouseSpeedX, mouseSpeedY);
        }
      });

      // Function to update displacement based on mouse/touch movement
      function updateDisplacement(speedX, speedY) {
        if (!isActive || !isHovering) return;

        const displacementX = Math.min(Math.max(speedX * 1.2, -40), 40);
        const displacementY = Math.min(Math.max(speedY * 1.2, -40), 40);

        // Apply different displacements with smoother motion
        if (redDuplicate) {
          const redX = displacementX * 1.4;
          const redY = displacementY * 0.9;
          redDuplicate.style.transform = `translate(${redX}px, ${redY}px)`;
          redDuplicate.style.opacity = "0.8";
          redDuplicate.style.transition =
            "transform 0.22s cubic-bezier(0.2, 0.8, 0.2, 1), opacity 0.25s ease";
        }

        if (greenDuplicate) {
          const greenX = displacementX * -1.1;
          const greenY = displacementY * 1.3;
          greenDuplicate.style.transform = `translate(${greenX}px, ${greenY}px)`;
          greenDuplicate.style.opacity = "0.8";
          greenDuplicate.style.transition =
            "transform 0.25s cubic-bezier(0.2, 0.8, 0.2, 1), opacity 0.25s ease";
        }

        if (blueDuplicate) {
          const blueX = displacementX * 0.9;
          const blueY = displacementY * -1.2;
          blueDuplicate.style.transform = `translate(${blueX}px, ${blueY}px)`;
          blueDuplicate.style.opacity = "0.8";
          blueDuplicate.style.transition =
            "transform 0.28s cubic-bezier(0.2, 0.8, 0.2, 1), opacity 0.25s ease";
        }

        // Use a smoother decay factor
        const newSpeedX = speedX * decayFactor;
        const newSpeedY = speedY * decayFactor;

        // Continue animation if still moving significantly
        if (Math.abs(newSpeedX) > 0.4 || Math.abs(newSpeedY) > 0.4) {
          animationFrame = requestAnimationFrame(() =>
            updateDisplacement(newSpeedX, newSpeedY)
          );
        } else {
          isActive = false;
          resetAllToCenter();
        }
      }

      // Set initial opacity for the duplicates
      if (redDuplicate) redDuplicate.style.opacity = "0.4";
      if (greenDuplicate) greenDuplicate.style.opacity = "0.4";
      if (blueDuplicate) blueDuplicate.style.opacity = "0.4";
    };

    return {
      logoImage,
      photoImage,
      barbaraRedImage,
      barbaraGreenImage,
      barbaraBlueImage,
      barbaraWhiteImage,
      barbaraPurpleImage,
      barbaraGoldImage,
      barbaraTealImage,
    };
  },
};
</script>

<style scoped>
header {
  max-width: var(--maxWidth);
  position: relative; /* Safari fix: constrains abs-pos children to header, not viewport */
  /* height: 100vh; */
  display: flex;
  flex-direction: column;
  align-content: stretch;
  margin-bottom: var(--largeSpace);
  padding: var(--largeSpace);
  justify-content: space-between;
  color: var(--text-white);
}

.ginourmousOnDesktop {
  font-size: 6.5em;
  margin-bottom: calc(var(--largeSpace) * 1.2);
  transform: translateX(-120px);
}

.lowerOnDesktop {
  position: absolute;
  transform: translateY(40px);
  white-space: nowrap;
}

.topHeaderBottomNoteCont {
  display: flex;
  justify-content: flex-end;
}
.topHeaderNote {
  max-width: 50%;
}

.topHeaderBottomNote {
  max-width: 40%;
}

.author-imageContCont {
  position: absolute;
  width: 50%;
  transform: translate(-10%, -50%);
}

.author-image-container {
  width: 75%; /* Reduced size for better centering */
  position: relative;
  margin: 0 auto;
  display: flex;
  justify-content: center; /* Center the image */
}

/* RGB Displacement effect */
.rgb-displacement-container {
  position: relative;
  width: 100%;
  max-height: 60vh; /* Limit maximum height */
  cursor: pointer;
  overflow: visible;
}

/* Remove the circle layers entirely */
.rgb-displacement-layer {
  display: none; /* Disable the circle layers */
}

.author-image {
  width: 100%;
  height: auto;
  max-height: 55vh; /* Limit image height */
  opacity: 0.6; /* Set opacity to 0.6 as requested */
  display: block;
  object-fit: contain; /* Ensure image maintains aspect ratio */
  z-index: 1;
  opacity: 0.1;
}

/* Duplicate images for RGB filters */
.author-image-duplicate {
  position: absolute;
  width: 100%;
  height: auto;
  max-height: 55vh; /* Limit image height */
  display: block;
  object-fit: contain; /* Ensure image maintains aspect ratio */
  opacity: 1; /* Full opacity for proper additive blending */
  transition: transform 0.15s ease-out, opacity 0.2s ease;
  pointer-events: none;
}

.red-duplicate {
  mix-blend-mode: screen; /* Additive blending for red channel */
  z-index: 3;
}

.green-duplicate {
  mix-blend-mode: screen; /* Additive blending for green channel */
  z-index: 2;
}

.blue-duplicate {
  mix-blend-mode: screen; /* Additive blending for blue channel */
  z-index: 4;
}

/* Keep one hidden image with visibility:hidden to maintain proper dimensions */
.author-image.hidden {
  visibility: hidden;
  display: block;
  height: auto;
  opacity: 0;
}

.barabaraImg {
  /* Style preserved for reference, can be removed */
  position: relative;
  width: 63%;
  border-radius: 270px;
  display: none;
}

.triangleTextCont {
  position: relative;
  text-align: center;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: -50px;
}

.triangleText {
  transform: translateY(50px);
}

/* .triangleTextCont > div {
  width: 50%;
} */

.trianguleImg {
  max-height: 12vh;
  width: auto;
  object-fit: contain;
  mix-blend-mode: difference;
  opacity: 0.6;
  margin: 0 auto;
}

.theWorld {
  white-space: nowrap;
}

.isAStage {
  margin-top: calc(var(--hugeFontSize) * 1.2);
  white-space: nowrap;
  margin-left: -100px;
  color: var(--purple-dark-tint-4);
}

.theWorld h1 {
  text-align: right;
}
.isAStage h1 {
  text-align: left;
  font-size: calc(var(--giganticFontSize) * 1.4);
}

.image-container {
  width: 100%;
}

@media (max-width: 680px) {
  .isAStage {
    --bigFontSize: 2.3rem;
    font-size: var(--hugeFontSize);
  }
  .isAStage h1 {
    font-size: calc(var(--giganticFontSize) * 1);
  }

  .topHeaderNote.text-left {
    max-width: 70%;
  }

  .ginourmousOnDesktop {
    font-size: 4.8em;
  }
  .topHeaderBottomNote {
    max-width: 50%;
  }

  .author-imageContCont {
    position: absolute;
    transform: translate(-20%, -50%);
  }

  .barabaraImg {
    /* Style preserved for reference, can be removed */
    position: relative;
    width: 75%;
    border-radius: 120px;
    display: none;
  }

  .author-image-container {
    width: 50%;
    margin-left: 20%;
  }

  .triangleTextCont {
    width: calc(100% - var(--largeSpace));
    transform: translate(0px, 25px);
    right: initial;
  }
  .trianguleImg {
    max-height: 9vh;
  }
}
</style>
